/**
 *	shop-schedule.directive.js
 */

import shopScheduleTpl from './shop-schedule.tpl.html!text';
import ShopScheduleCtrl from './shop-schedule.ctrl.js';

var shopScheduleDirective = function() {
 	return {
 		restrict: 'E',
 		replace: true,
 		transclude: true,
 		scope: {},
 		template: shopScheduleTpl,
 		controller: ShopScheduleCtrl,
 		controllerAs: 'ctrl',
 		bindToController: {
			program: '=',
 			exceptions: '='
 		}
 	};
 };

 export default shopScheduleDirective;